import { TrackingEvent } from '@/types/tracking'
import capture from '@repo/tracking/posthog'
import { useTrackingStore } from '@/hooks/use-tracking/store'
import { currentStepSelector } from '@/hooks/use-tracking/selectors'
import { productFieldsSelector } from '@/hooks/use-cart-product/selectors'
import { useProductStore } from '@/hooks/use-cart-product/store'

export function useTracking() {
  const productStore = useProductStore(productFieldsSelector)
  const { currentStep } = useTrackingStore(currentStepSelector)

  const trackEvent = (event: TrackingEvent) => {
    capture(event.eventName, {
      ...event.parameters,
      ...currentStep,
      hasUpselling: !!productStore?.selectedUpSelling,
      hasPromotion: !!productStore?.promotion,
      couponCode: productStore?.promotion?.couponId || undefined,
      upsellingId: productStore?.selectedUpSelling || undefined,
    })
  }

  return { trackEvent }
}
